import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Menu, X, Phone } from "lucide-react";
import { Link } from "@tanstack/react-router";


const links = [
  { href: "/#about", label: "Rólunk" },
  { href: "/#team", label: "Csapat" },
  { href: "/#services", label: "Szolgáltatások" },
  { href: "/gumiszereles-eger", label: "Gumiszerelés", route: true as const },
  { href: "/motorkerekpar-szerviz-eger", label: "Motorszerviz", route: true as const },
  { href: "/blog", label: "Blog", route: true as const },
  { href: "/#contact", label: "Kapcsolat" },
];

export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-background/80 backdrop-blur-xl border-b border-border"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <a href="/" className="flex items-center group">
          <div className="font-display text-xl tracking-wider">
            LAKROSZ AUTÓSZERVIZ
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-5 xl:gap-7">
          {links.map((l) =>
            l.route ? (
              <Link
                key={l.href}
                to={l.href}
                className="text-xs xl:text-sm uppercase tracking-wider text-muted-foreground hover:text-primary transition-colors relative group whitespace-nowrap"
              >
                {l.label}
                <span className="absolute -bottom-1 left-0 w-0 h-px bg-primary group-hover:w-full transition-all duration-300" />
              </Link>
            ) : (
              <a
                key={l.href}
                href={l.href}
                className="text-xs xl:text-sm uppercase tracking-wider text-muted-foreground hover:text-primary transition-colors relative group whitespace-nowrap"
              >
                {l.label}
                <span className="absolute -bottom-1 left-0 w-0 h-px bg-primary group-hover:w-full transition-all duration-300" />
              </a>
            ),
          )}
        </nav>

        <a
          href="tel:+36304787619"
          className="hidden md:inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-gradient-to-r from-primary to-primary-glow text-primary-foreground font-semibold text-sm hover:scale-105 transition-transform"
        >
          <Phone className="w-4 h-4" />
          +36 30 478 7619
        </a>

        <button
          className="lg:hidden p-2 text-foreground"
          onClick={() => setOpen(!open)}
          aria-label="Menü"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="fixed inset-x-0 top-20 bottom-0 z-50 overflow-y-auto lg:hidden bg-[#050505] border-t border-border shadow-2xl"
        >
          <div className="flex flex-col p-6 gap-4">
            {links.map((l) =>
              l.route ? (
                <Link
                  key={l.href}
                  to={l.href}
                  onClick={() => setOpen(false)}
                  className="text-base uppercase tracking-wider text-foreground hover:text-primary transition-colors"
                >
                  {l.label}
                </Link>
              ) : (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="text-base uppercase tracking-wider text-foreground hover:text-primary transition-colors"
                >
                  {l.label}
                </a>
              ),
            )}
            <a
              href="tel:+36304787619"
              className="inline-flex items-center gap-2 mt-2 px-5 py-3 rounded-full bg-primary text-primary-foreground font-semibold text-sm justify-center"
            >
              <Phone className="w-4 h-4" />
              +36 30 478 7619
            </a>
          </div>
        </motion.div>
      )}
    </motion.header>
  );
}
